{
  "nav": {
    "home": "Acasă",
    "services": "Servicii",
    "prices": "Prețuri",
    "projects": "Proiecte",
    "about": "Despre Khromatik",
    "contact": "Contact",
    "email": "Email",
    "linkedin": "LinkedIn"
  },
  "backToProjects": "Înapoi la proiecte",
  "projectOverview": "Prezentare proiect",
  "overview": "Prezentare",
  "challenge": "Provocarea",
  "businessNeed": "Necesitatea de business",
  "philosophy": "Filosofia",
  "goal": "Obiectivul",
  "solution": "Soluția",
  "polestarLandingPage": "Landing page Polestar Live",
  "footer": {
    "legal": "Informații legale"
  },
  "whatsapp": {
    "label": "Contact WhatsApp",
    "prefill": "Bună ziua. Doresc o discuție despre un proiect video sau de branding."
  },
  "cookies": {
    "title": "Cookie-uri și confidențialitate",
    "body": "Site-ul folosește analize opționale (Google Analytics și Microsoft Clarity) pentru a înțelege utilizarea. Cookie-urile neesențiale pot fi acceptate sau respinse. Stocarea esențială păstrează limba și această alegere.",
    "learnMore": "Informații suplimentare",
    "accept": "Accept toate",
    "reject": "Respinge cookie-urile neesențiale",
    "settings": "Setări cookie"
  }
}
